/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Exceptional_Planning_Copy_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select one or more units" |
*
* @param {Air_Handler_Unit_Exceptional_Planning_Copy_PlaceholderInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_exceptional_planning_copy_placeholder = /** @type {((inputs?: Air_Handler_Unit_Exceptional_Planning_Copy_PlaceholderInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Exceptional_Planning_Copy_PlaceholderInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Select one or more units")
	return /** @type {LocalizedString} */ ("Sélectionner un ou plusieurs équipements")
});